export const Endpoint = "tasks/create-personal-project";
export const Method = "POST";
export const RateLimitingConfig = {
    calls: 1,
    per: 5000,
};
